export const BUSINESS = {
  name: "Luxpress Detailing",
  tagline: "Quality You See. Results You Notice.",
  address: "476 City Road, South Melbourne VIC 3205",
  phoneDisplay: "0432 001 068",
  phoneHref: "tel:+61432001068",
  rating: "5.0",
  reviewCount: 26,
  areas: ["South Melbourne", "Port Melbourne", "Albert Park", "South Yarra", "Docklands", "Melbourne CBD"],
  socials: [
    { label: "Instagram", handle: "@luxpressdetailing", href: "https://www.instagram.com/luxpressdetailing" },
    { label: "TikTok", handle: "@luxpressdetailing_", href: "https://www.tiktok.com/@luxpressdetailing_" },
    { label: "Facebook", handle: "Luxpress Detailing", href: "https://www.facebook.com/830207553519101" },
  ],
};

export const HOURS = [
  { day: "Monday", time: "9:30 AM – 6:00 PM" },
  { day: "Tuesday", time: "9:30 AM – 6:00 PM" },
  { day: "Wednesday", time: "9:30 AM – 6:00 PM" },
  { day: "Thursday", time: "9:30 AM – 6:00 PM" },
  { day: "Friday", time: "9:30 AM – 6:00 PM" },
  { day: "Saturday", time: "9:30 AM – 6:00 PM" },
  { day: "Sunday", time: "9:30 AM – 6:00 PM" },
];

export const SERVICES = [
  { id: "basic-exterior-wash", name: "Basic Exterior Wash", price: 99, duration: "30–45 min", covers: "Hand wash, wheels, dry, exterior tidy" },
  { id: "basic-interior", name: "Basic Interior", price: 99, duration: "1–1.5 hrs", covers: "Vacuum, interior surfaces, glass, general interior clean" },
  { id: "mini-detail", name: "Mini Detail (Interior + Exterior)", price: 150, duration: "2–3 hrs", covers: "Combined interior and exterior treatment" },
  { id: "full-detail", name: "Full Detail (Interior + Exterior)", price: 250, duration: "3.5–4 hrs", covers: "Comprehensive interior and exterior detail" },
  { id: "pre-sale-detail", name: "Pre-Sale Detail", price: 500, duration: "Half day", covers: "Full presentation prep for private sale or trade-in" },
];

export const QUOTE_SERVICES = [
  {
    id: "ceramic-coating",
    name: "Ceramic Coating",
    path: "/services/ceramic-coating",
    blurb: "Paint correction, premium ceramic coatings, wheel coatings and interior fabric protection.",
  },
  {
    id: "ppf-vinyl-wraps",
    name: "Paint Protection Film & Vinyl Wraps",
    path: "/services/paint-protection-film",
    blurb: "Consultation-based film and wrap work, measured and cut for your car.",
  },
  { id: "window-tinting", name: "Window Tinting", path: null, blurb: "Consultation-based tinting, quoted on vehicle and film choice." },
  { id: "chrome-delete", name: "Chrome Delete / Blackout", path: null, blurb: "De-chroming and blackout work, quoted per vehicle." },
  { id: "caliper-resprays", name: "Caliper Resprays", path: null, blurb: "Consultation-based caliper refinishing." },
];

export const ALL_SERVICE_OPTIONS = [
  ...SERVICES.map((s) => ({ id: s.id, name: s.name })),
  ...QUOTE_SERVICES.map((s) => ({ id: s.id, name: s.name })),
  { id: "not-sure", name: "Not sure — advise me" },
];

export const REVIEWS = [
  { author: "Amarinder Grewal", text: "Whenever I need to love my car again I come here. The finish speaks for itself.", placeholder: false },
  { author: "LJ", text: "Great service and very accommodating.", placeholder: false },
  { author: "findsometime", text: "Couldn't be happier with the work from Luxpress Detailing.", placeholder: false },
  { author: "Placeholder — Verified Google Review", text: "Placeholder review text. Real Google review copy drops in here without touching the layout.", placeholder: true },
];

export const PROCESS = [
  { num: "01", title: "Inspect", text: "Every car starts under inspection lighting. Swirls, oxidation, contamination — we map the paint before we touch it, and we tell you exactly what we find." },
  { num: "02", title: "Correct", text: "Machine polishing removes the defects, not the clear coat. Measured, panel by panel, until the surface reads flat and deep." },
  { num: "03", title: "Protect", text: "pH-neutral chemicals and premium products only. Ceramic coatings, film and fabric protection matched to how the car is actually used." },
  { num: "04", title: "Deliver", text: "You collect the car under the same lights we inspect under. Nothing to hide, nothing to explain." },
];

export const IMAGES = {
  hero: "/assets/inspect.jpg",
  before: "/assets/before.jpg",
  after: "/assets/after.jpg",
  wheel: "/assets/rs3-wheel.jpg",
  interior: "/assets/interior.jpg",
  polisher: "/assets/correct.jpg",
  ceramic: "/assets/ceramic.jpg",
  ppf: "/assets/ppf.jpg",
  lambo: "/assets/lambo.jpg",
  inspect: "/assets/inspect.jpg",
  correct: "/assets/correct.jpg",
  protect: "/assets/protect.jpg",
  deliver: "/assets/deliver.jpg",
  team: "/assets/team.jpg",
  studio: "/assets/studio.jpg",
  corvette: "/assets/ceramic.jpg",
  orbit: "/assets/deliver.jpg",
  heroAlt: "/assets/inspect.jpg",
  tint: "/assets/after.jpg",
  blackout: "/assets/deliver.jpg",
  foam: "/assets/studio.jpg",
  foamMustang: "/assets/ceramic.jpg",
  ferrariWheel: "/assets/rs3-wheel.jpg",
};
